const discriCard = (UUserCard) => {
  let sex = ''
  //获取输入身份证号码 
  UUserCard = String(UUserCard);
  //获取出生日期 
  let dateBirth = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
  //获取性别 
  if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {//是男则执行代码 ... 
    sex = '0'
  } else {//是女则执行代码 ... 
    sex = '1'
  }
  //获取年龄 
  let myDate = new Date();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate();
  let age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
  if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
    age++;
  }
  return {
    sex,
    age,
    dateBirth
  }
}
const chekCode = (code)=> {
  code = String(code)
  let validateID = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return validateID.test(code)
}

const chekPhone = (phone)=> {
  phone = String(phone)
  let validateID = /^1[0-9]{10}$/;
  return validateID.test(phone)
}

export {
  discriCard,
  chekCode,
  chekPhone
}